import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-profile',
  standalone: false,
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {
  private apiUrl = environment.apiBaseUrl + '/api/User';

  userId: number = 1;
  username: string = '';
  email: string = '';
  roleName: string = '';
  roleId: number | null = null;
  createdAt: string = '';
  lastLogin: string = '';
  firstName: string = '';
  lastName: string = '';
  phoneNumber: string = '';
  address: string = '';
  dateOfBirth: string = '';
  isEnabled: boolean = false;
  is2FAEnabled: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  isEditing: boolean = false;
  editUsername: string = '';
  editEmail: string = '';
  editFirstName: string = '';
  editLastName: string = '';
  editPhoneNumber: string = '';
  editAddress: string = '';
  editDateOfBirth: string = '';
  isSaving: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.loadUserProfile();
  }

  loadUserProfile() {
    const payload = this.authService.getTokenPayload();
    if (payload) {
      this.userId = Number(payload.Id || payload.id || payload.userId || payload.UserId || 1);
      this.username = payload.username || payload.email || 'User';
      this.email = payload.email || 'N/A';
      this.roleId = Number(payload.RoleId || payload.roleId || 0);
      this.roleName = payload.Role || payload.roleName || payload.role || this.getRoleNameById(this.roleId) || 'User';
      this.createdAt = payload.createdAt ? new Date(payload.createdAt).toLocaleString() : 'N/A';
      this.lastLogin = payload.lastLogin ? new Date(payload.lastLogin).toLocaleString() : 'N/A';
    }

    this.loadUserProfileFromApi();
  }

  loadUserProfileFromApi() {
    this.isLoading = true;
    this.errorMessage = '';

    this.http.get<any>(`${this.apiUrl}/${this.userId}`).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.status !== 'success' || !res.data) {
          this.errorMessage = res.message || 'User not found';
          this.initializeEditFields();
          return;
        }

        const user = res.data;
        this.userId = user.userId;
        this.email = user.email || '';
        this.roleId = user.roleId;
        this.roleName = this.getRoleNameById(user.roleId);
        this.isEnabled = user.isEnabled;
        this.is2FAEnabled = user.is2FAEnabled;
        this.firstName = user.firstName || '';
        this.lastName = user.lastName || '';
        this.phoneNumber = user.phoneNumber || '';
        this.address = user.address || '';
        this.dateOfBirth = user.dateOfBirth ? user.dateOfBirth.substring(0, 10) : '';
        this.username = this.getDisplayName();

        this.initializeEditFields();
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'Failed to load user profile';
        this.initializeEditFields();
      }
    });
  }

  initializeEditFields() {
    this.editUsername = this.username;
    this.editEmail = this.email;
    this.editFirstName = this.firstName;
    this.editLastName = this.lastName;
    this.editPhoneNumber = this.phoneNumber;
    this.editAddress = this.address;
    this.editDateOfBirth = this.dateOfBirth;
  }

  getRoleNameById(roleId: number): string {
    const roleMap: { [key: number]: string } = {
      1: 'Super Admin',
      2: 'Administrator',
      3: 'Editor',
      4: 'Viewer'
    };
    return roleMap[roleId] || 'User';
  }

  startEditing() {
    this.isEditing = true;
    this.initializeEditFields();
  }

  cancelEditing() {
    this.isEditing = false;
  }

  saveProfile() {
    this.isSaving = true;
    // Simulate save delay
    setTimeout(() => {
      this.email = this.editEmail;
      this.firstName = this.editFirstName;
      this.lastName = this.editLastName;
      this.phoneNumber = this.editPhoneNumber;
      this.address = this.editAddress;
      this.dateOfBirth = this.editDateOfBirth;
      this.username = this.getDisplayName();
      this.isSaving = false;
      this.isEditing = false;
      console.log('Profile updated locally:', { username: this.username, email: this.email });
    }, 1000);
  }

  changePassword() {
    // Navigate to change password page or open modal
    console.log('Change password clicked');
  }

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  private getDisplayName(): string {
    const fullName = `${this.firstName} ${this.lastName}`.trim();
    return fullName || this.email || 'User';
  }
}
